import loadable from "@loadable/component";

export const Input = loadable(() => import("./Input/index.ant"));
export const Button = loadable(() => import("./Button/index.ant"));
export const Form = loadable(() => import("./Form/index.ant"));
export const Loader = loadable(() => import("./Loader/index.ant"));
export const Table = loadable(() => import("./Table/index.ant"));
export const OpenNotification = loadable(() => import("./Alerts/index.ant"));
export const Password = loadable(() => import("./Password/index.ant"));
export const Card = loadable(() => import("./Card/index.ant"));
export const Layout = loadable(() => import("./Layout/index.ant"));
export const Sider = loadable(() => import("./Sider/index.ant"));
export const Content = loadable(() => import("./Content/index.ant"));
export const Menu = loadable(() => import("./Menu/index.ant"));
export const SearchButton = loadable(() => import("./Search/index.ant"));
export const AntBreadcrumb = loadable(() => import("./Breadcrumb/index.ant"));
export const AntDropdown = loadable(() => import("./Dropdown/index.ant"));
export const AntSelect = loadable(() => import("./Select/index.ant"));
export const AntTextArea = loadable(() => import("./TextArea/index.ant"));
export const Rate = loadable(() => import("./Rate/index.ant"));
export const Checkbox = loadable(() => import("./Checkbox/index.ant"));
export const AntRadio = loadable(() => import("./Radio/index.ant"));
export const Confirm = loadable(() => import("./ConfirmPopup/index.ant"));
export const Popovers = loadable(() => import("./Popover/index.ant"));
export const DatePicker = loadable(() => import("./DatePicker/index.ant"));
export const Switch = loadable(() => import("./Switch/index.ant"));
export const AntTooltip = loadable(() => import("./Tooltip/index.ant"));
export const Description = loadable(() => import("./Description/index.ant"));
export const Upload = loadable(() => import("./Upload/index.ant"));
export const UploadComment = loadable(() =>
  import("./UploaderComment/index.ant")
);
export const UploadStepForm = loadable(() =>
  import("./UploaderStepForm/index.ant")
);
export const Select = loadable(() => import("./Select/index.ant"));
export const MultiUpload = loadable(() => import("./MultiUpload/index.ant"));
export const CheckboxGroup = loadable(() =>
  import("./CheckboxGroup/index.ant")
);
export const AntCalendar = loadable(() => import("./Calendar/index.ant"));
export const RangeSlider = loadable(() => import("./RangeSlider/index.ant"));
export const DocumentUploader = loadable(() => import("./Upload/index.ant"));
export const CustomCheckbox = loadable(() => import("./CustomCheck/index.ant"));
export const AntRangePicker = loadable(() => import("./RangePicker/index.ant"));
export { default as Modal } from "./Modal/Modal";
